import PropTypes from 'prop-types';
import React from 'react';

import schemaResolver from '../../state/resolvers/schema/event';

import Meta from '../../components/Meta';

/**
 * Meta container.
 * Wraps the meta presentational component with schemata data
 */
const MetaContainer = ({ events, schemata, ...props }) => {
  let eventsSchema = [];

  if (events && events.length) {
    eventsSchema = events.map(schemaResolver);
  }

  return (
    <Meta schemata={(schemata || []).concat(eventsSchema || [])} {...props} />
  );
};

MetaContainer.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape()),
  schemata: PropTypes.arrayOf(
    PropTypes.shape({
      innerHTML: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
};

MetaContainer.defaultProps = {
  events: [],
  schemata: [],
};

export default MetaContainer;
